import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';


import { getMemberinfo } from "../../utils/utils";


import * as APIS from "../../utils/service";
import Select from '../../component/Select';

export default function CompanyworkEnd({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [memberinfos, setmemberinfos] = useState(''); 
    const [closeCker, setcloseCker] = useState(''); 
    const [lists, setlists] = useState([]); 
    const [popflag, setpopflag] = useState(false); 
    const [memberCount, setmemberCount] = useState(0); 




    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);



    useEffect(() => {
        listopen();
    }, []);
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {}
        APIS.postData('/v1/master/users', sender).then(({ data }) => {
            if(data){
                console.log(data);
                setlists(data);
                setmemberCount(data?.length-1);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }

    const companyCloseSubmit = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {}
        APIS.postData('/v1/master/closed', sender).then(({ data }) => {
            dispatch(
                useropen({
                    userdata: ""
                })
            );      
            navigate('/');   
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });      
    }
    return(
        <>
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={1} />
                </div>
                <div 
                    className='padding32'
                    style={{}}
                >
                    <div className='backbuttonarea'>
                        <div>
                            <button onClick={() => { navigate(-1); }}>
                                <img src={`./images/icons/back.svg`} /> 
                            </button>
                            <span className='fontsize16 bolds'>사무소 폐업</span>
                        </div>
                        <button onClick={() => { navigate('/CompanyInfo'); }}>
                            사무소 정보
                        </button>
                    </div>

                    <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                    }}>
                        <div>
                            <div className='pagetitle fontsize20 bolds'>사무소관리</div>
                            <div className='color666 margint8'>사무소 폐업을 원하시면 아래 단계에 따라 진행해 주세요.</div>
                        </div>
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                                width: 78, height: 48, border: '1px solid #ddd', borderRadius: 100
                            }}
                        >
                            <span className='fontsize20 bolds'>{memberCount === 0 ? 2 : 1}</span>
                            <span className='fontsize20 bolds color999'>/</span>
                            <span className='fontsize20 bolds color999'>2</span>
                        </div>                        
                    </div>
                    
                    <div style={{
                        display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', gap: 12, marginTop: 40
                    }}>
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                                width: 48, height: 48, borderRadius: 12, backgroundColor: '#333', color: '#fff', fontSize: 24,
                                fontWeight: 700
                            }}
                        >
                            1
                        </div>                          
                        <div>
                            <div className='pagetitle fontsize20 bolds'>소속된 직원이 없어야 합니다.</div>
                            <div className='margint8'>소속된 직원들을 퇴사처리 후 진행가능합니다.</div>
                            <div className='margint8'>현재 소속된 직원: <span className='colorF00'>{memberCount}</span>명</div>
                        </div>
                    </div>                    
                                             
                    {memberCount > 0 ? 
                    <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 12, marginTop: 20
                    }}>
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                                width: 48, height: 48, borderRadius: 12, backgroundColor: '#CCC', color: '#fff', fontSize: 24,
                                fontWeight: 700
                            }}
                        >
                            2
                        </div>                          
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12
                            }}
                        >
                            <div className='pagetitle fontsize20 bolds color999' >사무소 폐업 신청하기</div>
                            <button
                                style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                                    width: 140, height: 36, border: '1px solid #ccc', borderRadius: 100, fontWeight: 700,
                                    color: '#ccc'
                                }}
                            >
                                사무소 폐업 신청
                            </button>
                        </div>
                    </div>                       
                    :
                    <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 12, marginTop: 20
                    }}>
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                                width: 48, height: 48, borderRadius: 12, backgroundColor: '#333', color: '#fff', fontSize: 24,
                                fontWeight: 700
                            }}
                        >
                            2
                        </div>                          
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12
                            }}
                        >
                            <div className='pagetitle fontsize20 bolds'>사무소 폐업 신청하기</div>
                            <button
                                style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                                    width: 140, height: 36, border: '1px solid #F00', borderRadius: 100, fontWeight: 700,
                                    color: '#F00'
                                }}
                                onClick={() => {
                                    setpopflag(true);
                                }}
                            >
                                사무소 폐업 신청
                            </button>
                        </div>
                    </div>                     
                    }
  
                </div>
            </div>
        </Layout>
        {popflag === true &&
        <div className='PopupArea'>
            <div>
                <div className='PopupAreaBG' 
                    onClick={() =>() => {}}
                />
                <div className='PopupAreaContents'>
                    <div>
                        <div className="popTitle padding20">
                            <span >사무소 폐업 신청</span>
                            <button
                                onClick={() => {
                                    setpopflag(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" width='20' />                                            
                            </button>
                        </div>
                        <div className="padding32">
                            <div className='popcontents'>
                                <div style={{ width: '100%' }}>
                                    <div style={{ letterSpacing: -0.5}}>
                                        사무소를 폐업 합니다.<br /><br />
                                        1. 진행중인 공동중개는 전체 종료처리로 강제 변경됩니다.<br />
                                        2. 고객에게 전송 된 매물은 전체 회수처리 됩니다.<br />
                                        3. 폐업 이후 사무소 등록/소속 전까지 기능 이용이 제한됩니다.
                                    </div>
                                    <div 
                                        className='margint20'
                                        style={{
                                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                                        }}
                                    >
                                        <Radios
                                            linetype={'checkimg'}
                                            values={closeCker}
                                            setvalues={(e) => {
                                                if(closeCker === 0){
                                                    setcloseCker('');
                                                } else {
                                                    setcloseCker(e);
                                                }
                                            }}
                                            namevalue={[
                                                {names: '위 내용을 충분히 확인함', values: 0},
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />                                        
                                    </div>
                                </div>
                            </div>
                            <div className='popbuttons'>
                                <div>
                                    <Button
                                        disabled={true}
                                        buttonTxt={'취소'}
                                        onPress={() => { setpopflag(false); }}
                                    />                                    
                                </div>
                                <div>
                                    <Button
                                        disabled={closeCker === 0 ? false : true}
                                        buttonTxt={'폐업하기'}
                                        onPress={() => { 
                                            if(closeCker === 0){
                                                companyCloseSubmit();
                                            }
                                        }}
                                    />                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        }


        </>
    )
}

